import React from "react";
import { StyledLabel, InfoIcon } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import { Tooltip } from "@mui/material";
import ReactSwitch from "react-switch";
import classnames from "classnames";

type Props = {
    label: string;
    tooltipText: string;
    showTooltip: boolean;
    checked: boolean;
    onChange: () => void;
    switchClassName: string;
    isFieldDisabled: boolean;
    isConsult?: boolean;
};

export default function LabeledSwitch({
    label,
    tooltipText,
    showTooltip,
    checked,
    onChange,
    switchClassName,
    isFieldDisabled,
    isConsult,
}: Props) {
    const testId = switchClassName
        .split(" ")
        .find((cls) => cls.startsWith("fdl_icn_"))
        ?.replace("fdl_icn_", "fidelity-franchise-");
    return (
        <AvGroup className={isConsult ? "pe-none__clz" : ""}>
            <div className="d-flex justify-content-between">
                <StyledLabel className="mt-4" htmlFor="name">
                    {label}
                </StyledLabel>
                <Tooltip title={showTooltip ? tooltipText : ""}>
                    <div>
                        <InfoIcon
                            style={{ cursor: "pointer", marginTop: "24px" }}
                            className="pointer__clz hex_icn_FRretail ml-5"
                            height={25}
                            width={25}
                            fill="black"
                        />
                    </div>
                </Tooltip>
                <div style={{ marginTop: "24px" }}>
                    <ReactSwitch
                        data-testid={testId}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={checked}
                        onChange={onChange}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={52}
                        height={20}
                        className={classnames(switchClassName, {
                            "not-allowed-icon__clz": isFieldDisabled,
                        })}
                    />
                </div>
            </div>
        </AvGroup>
    );
}
